export function generateFAQSchema({ service, city, zip, faqs = [] }) {
  let mainEntity = [];

  function escapeJSONLD(str) {
    return str?.trim().replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  if (faqs && faqs.length > 0) {
    mainEntity = faqs
      .filter(f => f.question?.trim() && f.answer?.trim()) // remove empty
      .map(f => ({
        "@type": "Question",
        "name": escapeJSONLD(`Modern Build Home Remodeling: ${f.question}`),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": escapeJSONLD(f.answer),
        },
      }));
  } else {
    const templateQuestions = [
      {
        q: `Do I need HOA approval for ${service} in ${city}, CA ${zip}?`,
        a: `It depends on your neighborhood. We can assist with HOA paperwork and local permit requirements.`,
      },
      {
        q: `How long does a typical ${service} project take in ${city}?`,
        a: `Most ${service} projects in ${city}, CA ${zip} are completed within 2–4 weeks, depending on scope and permit timelines.`,
      },
      {
        q: `Is financing available for ${service} in ${city}, California?`,
        a: `Yes, we offer 100% financing options with $0 down for qualified homeowners in ${city}, CA ${zip}.`,
      },
    ];

    mainEntity = templateQuestions.map(({ q, a }) => ({
      "@type": "Question",
      "name": escapeJSONLD(q),
      "acceptedAnswer": {
        "@type": "Answer",
        "text": escapeJSONLD(a),
      },
    }));
  }

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": mainEntity,
  };
}
